<style lang="scss" scoped>
  .daily-box{
    overflow: hidden;
    background: #f7f7f7;
    img{
      width: 16px;
      vertical-align: middle;
      margin-right: 12px;
      margin-top: -2px;
    }
    .room{
      float: left;
      width: 184px;
      box-sizing: border-box;
      .search{
        height: 30px;
        border: 1px solid #e6e6e6;
        background: #ffffff;
        margin-bottom: 6px;
        line-height: 30px;
        box-sizing: border-box;
        padding-left: 12px;
        cursor: pointer;
        background: #ffffff url("../../common/imgs/search.svg") no-repeat 156px center/16px;
      }
      .room-list{
        border-right: 1px solid #e6e6e6;
        background: #ffffff;
        text-align: center;
        border-top: 1px solid #e6e6e6;
        li{
        padding-top: 10px;
        padding-bottom: 10px;
          position: relative;
          border-bottom: 1px solid #e6e6e6;
          cursor: pointer;
        }
        font-size: 14px;
        li.active{
          font-size: 16px;
          background-color: #114c9a;
          color: #ffffff;
          &:after{
            content: '';
            position: absolute;
            display: block;
            width: 0;
            height: 0;
            border: 10px solid #114c9a;
            border-top-width: 13px;
            border-bottom-width: 13px;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-right-color: transparent;
            right: -20px;
            top: 50%;
            margin-top: -10px;
          }
        }
        li.disable{
          color: #cccccc;
          font-size: 14px;
          cursor: auto;
        }
      }
    }
    .time{
      float: left;
      background-color: #ffffff;
      width: 618px;
      box-sizing: border-box;
      .time-tab{
        background-color: #f7f7f7;
        overflow: hidden;
        text-align: right;
        font-size: 0;
        li{
          display: inline-block;
          font-size: 12px;
          width: 100px;
          height: 36px;
          line-height: 36px;
          background-color: #dddddd;
          border-top-left-radius: 25px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
          &.active{
            background: #114c9a;
          }
        }
      }
    }
    .time-con{
      background-color: #ffffff;
      border-top: 1px solid #e6e6e6;
      box-sizing: border-box;
      padding: 20px;
      font-size: 14px;
      .item{
        background-color: #f2f2f2;
        border-radius: 12px;
        padding: 15px 20px;
        margin-bottom: 10px;
        .title{
          font-size: 16px;
          color: #333333;
        }
        .time-range{
          font-size: 16px;
          color: #333333;
        }
        .btn{
          /* background: #ec6941; */
          display: inline-block;
          font-size: 14px;
          color: #666666;
          padding: 2px 4px;
          margin-right: 5px;
            img{
              width: 12px;
              margin-top: -2px;
              margin-right: 4px;
            }
          }
        .zhuxi{
          font-size: 14px;
          .btn{
            /* background-color: #F19149; */
          }
        }
        .zhuchi{
          font-size: 14px;
          margin-top: 12px;
          .btn{
           /*  background-color: #ec6941; */
          }
        }
        .teacher{
          /* background-color: #80C269; */
        }
        .item-range-list{
          margin-top: 20px;
          &:first-child{
            margin-top: 0;
          }
          .title{
            font-size: 14px;
            color: #666666;
            margin-bottom: 5px;
            b{
              width: 6px;
              height: 6px;
              display: inline-block;
              background-color: #dddddd;
              border-radius: 50%;
              margin-right: 8px;
              vertical-align: middle;
            }
          }
          .time-range{
            margin-right: 34px;
            color: #114c9a;
          }
        }
      }
    }
  }
  .fixed{
    position: fixed;
  }
</style>

<template>
  <div class="daily-box">
    <div v-show="!showSearch">
      <div v-if="activeRoomIndex!=null" ref="room" class="room">
        <div v-touch-ripple class="search" @click="search">
          {{ $t("message.tpl1.daily.keyWords") }}
        </div>
        <ul class="room-list">
          <li :style="{color: color}">
            {{ $t("message.tpl1.daily.metting") }}
          </li>
          <li v-touch-ripple @click="selectRoom(item,i)" :class="{active: activeRoomIndex===i,disable: currentDateRoom.indexOf(item) === -1}" v-for="(item,i) in allRooms" :key="i">
            {{item}}
          </li>
        </ul>
      </div>
      <div ref="time" class="time">
        <div v-if="activeDateIndex!=null" class="time-tab">
          <ul>
            <li v-touch-ripple @click="selectDate(i,item)"
                :class="{active: activeDateIndex === i}" v-for="(item,i) in data.cpnData">
              {{item.date}}
            </li>
          </ul>
        </div>
        <ul   v-if="activeRoomIndex!=null" ref="time-cons" class="time-con">
          <li v-for="(item,i) in curentData.calendars" :key="i">
            <!--一级日程-->
            <div class="item">
              <h2 class="title">
                <img src="../../common/imgs/book.svg" alt="">{{item.calTitle}}
              </h2>
              <h2 class="time-range" style="margin-bottom: 12px;">
                <img src="../../common/imgs/clock.svg" alt="">
                <span>{{item.calStart}} - {{item.calEnd}}</span>
                </h2>
              <!--主席-->
              <div>
                <h2 class="zhuxi" v-if="item.chairman.length>0">
                  <div class="btn">
                    <!-- <img src="../../common/imgs/people.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.zhuxi") }}:
                  </div>
                  <span style="margin-right: 12px;" class="zhu-xi" v-for="(zx,k) in item.chairman">{{zx.uName}} </span>
                </h2>
                <h2 class="zhuchi" v-if="item.hosts.length>0">
                  <div class="btn">
                    <!-- <img src="../../common/imgs/ht.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.zhuchi") }}:
                  </div>
                  <span style="margin-right: 12px;" v-for="(calhost,h) in item.hosts" class="jia-bin">{{calhost.uName}}</span>
                </h2>
                <h2 class="zhuchi" v-if="item.speakers.length>0">
                  <div class="btn teacher">
                    <!-- <img src="../../common/imgs/message.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.teacher") }}:
                  </div>
                  <span  v-for="(speak,j) in item.speakers">{{speak.uName}} </span>
                </h2>
                <h2 class="zhuchi" v-if="item.commenter.length>0">
                  <div class="btn teacher">
                    <!-- <img src="../../common/imgs/message.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.dianping") }}:
                  </div>
                  <span  v-for="(c,j) in item.commenter">{{c.uName}} </span>
                </h2>
                <h2 class="zhuchi" v-if="item.translater.length>0">
                  <div class="btn teacher">
                    <!-- <img src="../../common/imgs/message.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.fanyi") }}:
                  </div>
                  <span  v-for="(t,j) in item.translater">{{t.uName}} </span>
                </h2>
              </div>
            </div>
            <!--time-range 二级日程-->
            <div class="item" v-if="item.subCals.length>0">
              <div class="item-range-list" v-for="(cal,j) in item.subCals">
                <h2 class="title"><b></b>{{cal.calTitle}}</h2>
                <span class="time-range" style="margin-left:14px;">{{cal.calStart}}-{{cal.calEnd}}</span>
                <span v-if="cal.speakers.length>0">
                  <span class="btn teacher">
                    <!-- <img src="../../common/imgs/message.svg" alt=""> -->
                    {{ $t("message.tpl1.daily.teacher") }}:</span>
                  <span style="margin-right: 12px;" v-for="(speak,j) in cal.speakers">{{speak.uName}} </span>
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="data.cpnData && showSearch">
      <dailySearch style="margin:0;" :color="color" :propData = "data.cpnData"></dailySearch>
    </div>
  </div>
</template>
<script>
  import dailySearch from '@/components/tpl2/dailySearch/dailySearch'
  import {hasClass,addClass,removeClass,getScrollTop} from 'outils'
  import bus from '@/bus'
export default {
  data() {
    return {
      activeRoomIndex: null,
      //当前的日期对应的房间index
      activeRIndex: 0,
      activeDateIndex: null,
      activeRoomId: '0-0',
      showSearch: false
    }
  },
  props:{
    data: {
      type: Object
    },
    color: {
      type: String,
      default: '#f39800'
    }
  },
  methods:{
    selectDate(index,date){
      this.activeDateIndex = index;
      // this.activeRoomIndex = i;
      for(let i=0;i<this.allRooms.length;i++){
        for(let j=0;j<this.currentDateRoom.length;j++){
          if(this.allRooms[i] === this.currentDateRoom[j]){
            this.activeRoomIndex = i;
            this.computedRIndex(this.allRooms[i]);
            this.updateHeight()
            return
          }
        }
      }
      
    },
    computedRIndex(item){
      const currentRooms = this.currentDateRoom;
      currentRooms.map((r,i)=>{
        if(r === item){
          this.activeRIndex = i
        }
      })
    },
    selectRoom(item,i){
      if(this.currentDateRoom.indexOf(item) === -1) return;
    // 获取当前房间对应的房间index
      this.activeRoomIndex = i;

      this.computedRIndex(item)
      this.updateHeight()
    },
    setPos(){
      const topEl = this.$parent.$parent.$refs.top;
      const topHeight = topEl.offsetHeight;
      const topLeft = (window.innerWidth - 1280 - 16)/2;
      const scrollTop = getScrollTop();
      console.log(topHeight,topLeft);
      const roomWidth = this.$refs['room'] && this.$refs['room'].offsetWidth;
      if(scrollTop > topHeight){
        addClass(this.$refs['room'],'fixed');
        this.$refs['room'].style.left = topLeft + 'px';
        this.$refs['room'].style.top = 0 + 'px';
        this.$refs['time'].style.marginLeft = roomWidth + 'px';
      }else{
        this.$refs['time'].style.marginLeft = 0 + 'px';
        removeClass(this.$refs['room'],'fixed');
      }
      
    },
    search(){
      this.showSearch = true;
      setTimeout(()=>{
        window.scrollTo(0,0)
      },20)
    },
    updateHeight(){
      let that = this
      setTimeout(() => {
        const timeHeight = that.$refs['time-cons'].offsetHeight + 40
        const roomHeight = that.$refs['room'].offsetHeight
        console.log('-------')
        console.log(timeHeight,roomHeight)
        const maxHeight = Math.max(timeHeight,roomHeight)
        that.$refs['time'].style['min-height'] = maxHeight + 'px'
      }, 20);
     
    }
  },
  computed:{
    //根据当前日期，返回当前日期的rooms
    currentDateRoom(){
      let ret = [];
      this.data.cpnData[this.activeDateIndex].rooms.map((item,i)=>{
        ret.push(item.name)
      });
      return ret;
    },
    allRooms(){
      let ret = [];
      this.data.cpnData.map((item,i)=>{
        item.rooms.map((room,j)=>{
          if(ret.indexOf(room.name) < 0){
            ret.push(room.name)
          }
        })
      });
      return ret;
    },
    curentData(){
      try{
        return this.data.cpnData[this.activeDateIndex].rooms[this.activeRIndex]
      }catch (err){
        return ''
      }
    }
  },
  components:{
    dailySearch
  },
  mounted(){
    window.addEventListener('scroll',this.setPos);
    bus.$on('closeSearch', flag => {
      this.showSearch = flag
    })
      this.updateHeight()
        let activeTime
         let roomA
         this.data.cpnData.map((item,index)=>{
         if(item.date_def_fl == 1){
            activeTime=index;
          }
          console.log(item.rooms)
          item.rooms.map((room,i)=>{
              
              if(room.room_def_fl == '1'){
                console.log(i)
                 roomA = i
              }
          })
          // item.rooms.map((roomItem,roomIndex)=>{
         
          // })
        })
       this.activeDateIndex = activeTime
       this.activeRoomIndex = roomA

       this.activeRIndex = this.activeRoomIndex
  },
  beforeDestroy(){
    window.removeEventListener('scroll',this.setPos);
  }
}
</script>




// WEBPACK FOOTER //
// daily.vue?ff659540